import axios from "axios";

export default async function getFairnessData(access_token, saleId, eventId) {
  if (!saleId || !eventId) return;
  const response = await axios.post(
    `${process.env.REACT_APP_ORGANISER_API}/fairness/get`,
    { eventId, saleId },
    {
      headers: {
        token: access_token,
      },
    }
  );

  if (!response.data) {
    throw new Error("Some error occurred while fetching.");
  }
  if (response.data.error) {
    throw new Error(response.data.error);
  }

  return response.data;
}
